import { Building2, Phone } from 'lucide-react';
import { useTranslation } from '@parentpath/i18n';
import type { HospitalRule } from '../types';

interface HospitalBannerProps {
  isMet: boolean;
  rule: HospitalRule;
  details: string;
}

export function HospitalBanner({ isMet, rule, details }: HospitalBannerProps) {
  const { t } = useTranslation('contractionTimer');
  if (!isMet) return null;

  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-4 shadow-lg animate-pulse-slow">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
          <Building2 className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="text-white font-bold text-lg">{t('hospital.title')}</h3>
          <p className="text-white/90 text-sm mt-0.5">
            {t('hospital.ruleMet', { rule })}
          </p>
          <p className="text-white/70 text-xs mt-1">{details}</p>
        </div>
      </div>

      {/* Quick call button */}
      <a
        href="tel:112"
        className="mt-3 w-full py-2.5 bg-white text-red-600 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-gray-100 transition-colors"
      >
        <Phone className="w-5 h-5" />
        {t('hospital.emergency')}
      </a>
    </div>
  );
}
